import React from "react";
import { useTranslation, Trans } from "react-i18next";

// for styles
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@material-ui/core/";

// sass
import "../../scss/common.scss";
import "../../scss/component.scss";
import {dateFormat} from "../../utils/convert";


// モーダルに何か渡したい場合はここ追加する
type Props = {
  isShow: boolean,
  date:string,
  checkIn:string,
  hotelName:string,
  callbackHotelCancel(date:string, checkIn:string):void
  callback: () => void,
}

const DialogHotelCancel: React.FC<Props> = ({
  isShow,
  date,
  checkIn,
  hotelName,
  callbackHotelCancel,
  callback
}) => {
  const { t, i18n } = useTranslation();

  return (
    <>
    {/* ダイアログ:検索変更 */}
    <div>
      <Dialog
        open={isShow}
        onClose={callback}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="dialog"
      >
        <DialogTitle id="alert-dialog-title" className="dialog-title">
          {t("ホテルの日程のキャンセル")}
        </DialogTitle>
        <DialogContent className="dialog-content">
          <DialogContentText id="alert-dialog-description" className="dialog-content-text">
            <Trans i18nKey={"{$hotelName}の{$date}以降の日程をキャンセルしてもよろしいですか？"} values={{hotelName: hotelName, date: dateFormat(date, t("YYYY年MM月DD日"), i18n.language)}} />
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action">
          <Button className="button-dialog-border-small-blue w-110" onClick={callback}>{t("いいえ")}</Button>
          <Button className="button-dialog-small-blue w-110" onClick={() => callbackHotelCancel(date, checkIn)} autoFocus>
            {t("はい")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
    </>
  );
};

export default DialogHotelCancel;
